<template>
  <div class="absolute bg-black bg-opacity-50 top-0 left-0 z-50 w-full h-full flex items-center">
    <div class="w-2/3 mx-auto bg-classen__secondary h-5/6 p-5 pt-10 classen__rounded_large">
      <div @click="$emit('onClose')" class="float-right text-2xl cursor-pointer"><i
        class="fas fa-times"></i>
      </div>
      <div id="img" class="h-4/5">
        <img :src="asset" class="h-9/10 ml-auto mr-auto" alt="image preview"/>
      </div>
      <div id="actions" class="flex justify-center">
        <button @click="$emit('onClickDownload')" id="download"
                class="classen__button hover__button classen__rounded_full mr-5">
          <p class="leading-none">{{ getTranslation('download') }}</p>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import getTranslation from "../mixins/getTranslation";
import download from "../mixins/download";

export default {
  name: "AssetPopup",

  mixins: [getTranslation, download],

  props: {
    asset: {required: true, type: String},
    name: {required: true, type: String},
  }
}
</script>

<style scoped>
#download {
  justify-items: end;
}

.classen__button {
  padding: 0
}

#img {
  margin-top: 5%;
}
</style>
